import { defineMessages } from 'react-intl';

const CROSS_PATH_STRINGS = defineMessages({
  RUNNER_IMAGE_ALT: {
    defaultMessage: 'Runner running in the distance'
  }
});

export default CROSS_PATH_STRINGS;
